import { InjectionToken } from "@angular/core";

export const CUBIQ_BROKER_SOURCE_PORT = new InjectionToken<MessagePort>("cubiq_broker_source");
export const CUBIQ_BROKER_TARGET_PORT = new InjectionToken<MessagePort>("cubiq_broker_target");
export const CUBIQ_BROKER_PORT = new InjectionToken<MessagePort>("cubiq_broker_port");
export const CUBIQ_BROKER = new InjectionToken<MessagePort>("cubiq_broker");

export const SESSION_TIMESTAMP = new InjectionToken<string>("sessionTimestamp");
export const SESSION_IS_ROOT = new InjectionToken<string>("sessionIsRoot");
export const CUBIQ_LOGIN_CLOSE_AFTER_TOKEN = new InjectionToken<boolean>(
  "CUBIQ_LOGIN_CLOSE_AFTER_TOKEN",
);
export const MISC_STATIC_DATA = `__StaticDataProfileImpl_misc`;

export const ENCODABLE_TYPE_ERRORS: string = "com.bcdfx.broker.ErrorsImpl";
